import { render, staticRenderFns } from "./SendPasswordInstructions.vue?vue&type=template&id=c297c4d6&scoped=true&"
import script from "./SendPasswordInstructions.vue?vue&type=script&lang=ts&"
export * from "./SendPasswordInstructions.vue?vue&type=script&lang=ts&"
import style0 from "./SendPasswordInstructions.vue?vue&type=style&index=0&id=c297c4d6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c297c4d6",
  null
  
)

export default component.exports